(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'clubInfoResolver', 'memberRosterResolver', 'favoritesResolver', 'subgroupsResolver', 'statsDashboardResolver', 'handicapReviewResolver', 'transactionLogResolver', 'clubReportsResolver', 'addMemberResolver', 'clubContactResolver', 'facilityResolver', 'clubAdminResolver', 'teeTimeComparisonResolver'];
    function configRoutes($stateProvider, clubInfoResolver, memberRosterResolver, favoritesResolver, subgroupsResolver, statsDashboardResolver, handicapReviewResolver, transactionLogResolver, clubReportsResolver, addMemberResolver, clubContactResolver, facilityResolver, clubAdminResolver, teeTimeComparisonResolver) {
        $stateProvider
            // Club Admin
            .state('club-admin', {
                url: '/clubs/:clubId',
                component: 'sc3ClubAdmin',
                resolve: clubAdminResolver,
                redirectTo: { state: 'club-admin.info' },
                params: {
                    clubId: { value: null, type: 'int' },
                    club: null
                },
                data: {
                    requireAdmin: true
                }
            })

            // Club Info
            .state('club-admin.info', {
                url: '',
                component: 'sc3ClubInfo',
                resolve: clubInfoResolver
            })

            // Member Roster
            .state('club-admin.member-roster', {
                url: '/member-roster',
                component: 'sc3MemberRoster',
                resolve: memberRosterResolver,
                params: {
                    expiresIn: { value: null, type: 'int' }
                }
            })

            // Favorites
            .state('club-admin.favorites', {
                url: '/favorites',
                component: 'sc3Favorites',
                resolve: favoritesResolver
            })

            // Subgroups
            .state('club-admin.subgroups', {
                url: '/subgroups',
                component: 'sc3Subgroups',
                resolve: subgroupsResolver
            })

            // Transfers
            //.state('club-admin.transfers', {
            //    url: '/transfers',
            //    component: 'sc3Transfers',
            //    resolve: transfersResolver
            //})

            // Stats Dashboard
            .state('club-admin.stats-dashboard', {
                url: '/stats-dashboard',
                component: 'sc3StatsDashboard',
                resolve: statsDashboardResolver
            })

            // Handicap Review
            .state('club-admin.handicap-review', {
                url: '/handicap-review',
                component: 'sc3HandicapReview',
                resolve: handicapReviewResolver
            })

            // Transaction Log
            .state('club-admin.transaction-log', {
                url: '/transaction-log',
                component: 'sc3TransactionLog',
                resolve: transactionLogResolver
            })

            // Tee Time Comparison
            .state('club-admin.tee-time-comparison', {
                url: '/tee-time-comparison',
                component: 'sc3TeeTimeComparison',
                resolve: teeTimeComparisonResolver
            })

            // Club Reports
            .state('club-admin.reports', {
                url: '/reports',
                component: 'sc3ClubReports',
                resolve: clubReportsResolver
            })

            // Add Member
            .state('club-admin.add-member', {
                url: '/add-member',
                component: 'sc3AddMember',
                resolve: addMemberResolver
            })

            // Club Contact
            .state('club-admin.club-contact', {
                url: '/club-contact',
                component: 'sc3ClubContact',
                resolve: clubContactResolver
            })

            // Facility
            .state('club-admin.facility', {
                url: '/facility',
                component: 'sc3ClubFacility',
                resolve: facilityResolver
            });
    }
})();